/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SyncGetChangeOutRequest } from './SyncGetChangeOutRequest';
import {
    SyncGetChangeOutRequestFromJSON,
    SyncGetChangeOutRequestFromJSONTyped,
    SyncGetChangeOutRequestToJSON,
    SyncGetChangeOutRequestToJSONTyped,
} from './SyncGetChangeOutRequest';
import type { SyncUndercarriageChangeOutRequest } from './SyncUndercarriageChangeOutRequest';
import {
    SyncUndercarriageChangeOutRequestFromJSON,
    SyncUndercarriageChangeOutRequestFromJSONTyped,
    SyncUndercarriageChangeOutRequestToJSON,
    SyncUndercarriageChangeOutRequestToJSONTyped,
} from './SyncUndercarriageChangeOutRequest';
import type { InspectionDto } from './InspectionDto';
import {
    InspectionDtoFromJSON,
    InspectionDtoFromJSONTyped,
    InspectionDtoToJSON,
    InspectionDtoToJSONTyped,
} from './InspectionDto';
import type { UpsertEquipmentRequest } from './UpsertEquipmentRequest';
import {
    UpsertEquipmentRequestFromJSON,
    UpsertEquipmentRequestFromJSONTyped,
    UpsertEquipmentRequestToJSON,
    UpsertEquipmentRequestToJSONTyped,
} from './UpsertEquipmentRequest';
import type { InspectionSyncDetailsRequest } from './InspectionSyncDetailsRequest';
import {
    InspectionSyncDetailsRequestFromJSON,
    InspectionSyncDetailsRequestFromJSONTyped,
    InspectionSyncDetailsRequestToJSON,
    InspectionSyncDetailsRequestToJSONTyped,
} from './InspectionSyncDetailsRequest';

/**
 * 
 * @export
 * @interface SaveInspectionsRequest
 */
export interface SaveInspectionsRequest {
    /**
     * 
     * @type {InspectionSyncDetailsRequest}
     * @memberof SaveInspectionsRequest
     */
    syncDetails?: InspectionSyncDetailsRequest;
    /**
     * 
     * @type {Array<UpsertEquipmentRequest>}
     * @memberof SaveInspectionsRequest
     */
    equipmentItems?: Array<UpsertEquipmentRequest>;
    /**
     * 
     * @type {Array<InspectionDto>}
     * @memberof SaveInspectionsRequest
     */
    inspections?: Array<InspectionDto>;
    /**
     * 
     * @type {Array<SyncUndercarriageChangeOutRequest>}
     * @memberof SaveInspectionsRequest
     */
    undercarriageChangeOuts?: Array<SyncUndercarriageChangeOutRequest>;
    /**
     * 
     * @type {Array<SyncGetChangeOutRequest>}
     * @memberof SaveInspectionsRequest
     */
    getChangeOuts?: Array<SyncGetChangeOutRequest>;
}

/**
 * Check if a given object implements the SaveInspectionsRequest interface.
 */
export function instanceOfSaveInspectionsRequest(value: object): value is SaveInspectionsRequest {
    return true;
}

export function SaveInspectionsRequestFromJSON(json: any): SaveInspectionsRequest {
    return SaveInspectionsRequestFromJSONTyped(json, false);
}

export function SaveInspectionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveInspectionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'syncDetails': json['syncDetails'] == null ? undefined : InspectionSyncDetailsRequestFromJSON(json['syncDetails']),
        'equipmentItems': json['equipmentItems'] == null ? undefined : ((json['equipmentItems'] as Array<any>).map(UpsertEquipmentRequestFromJSON)),
        'inspections': json['inspections'] == null ? undefined : ((json['inspections'] as Array<any>).map(InspectionDtoFromJSON)),
        'undercarriageChangeOuts': json['undercarriageChangeOuts'] == null ? undefined : ((json['undercarriageChangeOuts'] as Array<any>).map(SyncUndercarriageChangeOutRequestFromJSON)),
        'getChangeOuts': json['getChangeOuts'] == null ? undefined : ((json['getChangeOuts'] as Array<any>).map(SyncGetChangeOutRequestFromJSON)),
    };
}

export function SaveInspectionsRequestToJSON(json: any): SaveInspectionsRequest {
    return SaveInspectionsRequestToJSONTyped(json, false);
}

export function SaveInspectionsRequestToJSONTyped(value?: SaveInspectionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'syncDetails': InspectionSyncDetailsRequestToJSON(value['syncDetails']),
        'equipmentItems': value['equipmentItems'] == null ? undefined : ((value['equipmentItems'] as Array<any>).map(UpsertEquipmentRequestToJSON)),
        'inspections': value['inspections'] == null ? undefined : ((value['inspections'] as Array<any>).map(InspectionDtoToJSON)),
        'undercarriageChangeOuts': value['undercarriageChangeOuts'] == null ? undefined : ((value['undercarriageChangeOuts'] as Array<any>).map(SyncUndercarriageChangeOutRequestToJSON)),
        'getChangeOuts': value['getChangeOuts'] == null ? undefined : ((value['getChangeOuts'] as Array<any>).map(SyncGetChangeOutRequestToJSON)),
    };
}

